import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "page-container--panel",
            style: _normalizeStyle(_ctx.getBackgroundStyle)
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", null, "404", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("h5", null, "page not found", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "sorry" }, " Sorry, we can't find the page you are trying to reach. Don't worry though, everything else should be in order. ", -1)),
            _createElementVNode("p", null, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Back to Home", -1)
                ]))]),
                _: 1
              })
            ])
          ], 4)
        ])
      ])
    ]),
    _: 1
  }))
}